import * as App from '../../app';
export function updateCoins(coins) {
    var coinsBefore = App.storage.get().coins;
    App.storage.upd({ coins: coins });
    var delta = coins - coinsBefore;
    if (coinsBefore > 0 && delta > 0) {
        App.emitCoinsEvent(delta);
    }
}
if (DEVELOPMENT) {
    // @ts-ignore
    window['updateCoins'] = updateCoins;
}
